// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"347ded3a","299":"78c9228b","352":"65d56caf","452":"f5f9b454","455":"c1ebe4c5","545":"6ff800f4","597":"6d158c64","657":"abf4d7c1","706":"ab55d2b1","811":"8237f837","946":"4d003193","958":"2873315c","959":"33839c7d","977":"6bba27b6"}[chunkId] + ".chunk.js";
};